<template>
  <div class="scrollable-div display-scrollbar">
    <table class="full-width-table options-table">
      <tbody>
        <tr class="table-header">
          <th style="width: 12%">Name</th>
          <th>Options</th>
          <th style="width: 3rem"></th>
        </tr>
        <tr v-for="picklist in picklists">
          <td id="name">{{ picklist.name }}</td>
          <td id="items">
            <span v-for="item in picklist.items" :key="item.id">{{ item.NAME }}</span>
          </td>
          <td class="context-container">
            <div
              class="hover-icon"
              @click="
                showPopup = true;
                showOptionsName = picklist.name;
                showOptionsId = picklist.id;
              ">
              <img id="noHover" src="../../assets/pencil.svg" />
              <img id="hover" src="../../assets/pencil-hover.svg" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <OptionsPopup
    v-if="showPopup"
    @closePopup="
      showPopup = false;
      refetch();
    "
    :name="showOptionsName"
    :options="showOptions"
    :picklistid="showOptionsId"
    :otherColumns="otherColumns[showOptionsName]" />
</template>

<script>
import usePicklistItemsQuery from '@/composables/usePicklistItemsQuery';
import OptionsPopup from '@/components/OptionsPopup.vue';

export default {
  name: 'Options',
  components: {
    OptionsPopup,
  },
  setup() {
    return {
      refetch: usePicklistItemsQuery.refetchPickLists,
      picklists: usePicklistItemsQuery.pickLists,
    };
  },
  data() {
    return {
      showPopup: false,
      showOptionsName: null,
      showOptionsId: null,
      otherColumns: {
        'Interaction Types': [
          {
            name: 'SCOREACTION',
            title: 'Set Score',
            type: 'dropdown',
            dropdownOptions: [
              { name: 'None', value: null },
              { name: 'Hot', value: 'hot' },
              { name: 'Warm', value: 'warm' },
              { name: 'Cool', value: 'cool' },
            ],
          },
        ],
      },
    };
  },
  computed: {
    showOptions() {
      return Object.values(this.picklists).find((picklist) => picklist.id === this.showOptionsId)?.items || [];
    },
  },
  mounted() {
    //this.refetch();
  },
};
</script>

<style lang="scss" scoped>
.options-table {
  #name {
    vertical-align: top;
  }

  #items {
    span {
      display: inline-block;
      margin-right: 0.3rem;
      margin-bottom: 0.8rem;
      background: $tableBorderColor;
      border-radius: 5rem;
      padding: 0.25rem 0.7rem;
      font-size: $fontSize14;
    }
  }
}
</style>
